var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
export const LogoutButton = (_a) => {
    var { logoutUrl = 'https://account.collegeboard.org/login/logout', isStudent, returnUrl, appId, label = 'Sign Out', className } = _a, props = __rest(_a, ["logoutUrl", "isStudent", "returnUrl", "appId", "label", "className"]);
    const onButtonClick = () => {
        window.location.href = `${logoutUrl}?appId=${appId}${returnUrl ? `&DURL=${encodeURI(returnUrl)}` : ''}${isStudent !== undefined ? `&idp=${isStudent ? 'ECL' : 'EPL'}` : ''}`;
    };
    return (React.createElement("button", Object.assign({ type: "button", onClick: onButtonClick, className: `cb-btn ${className}` }, props), label));
};
//# sourceMappingURL=logoutButton.js.map